import React from 'react';
import { useTranslation } from 'react-i18next';
import { googleOAUTHRedirect } from '../../services/auth';
import { useGoogleLogin } from '@react-oauth/google';
import { Button } from '@mui/material';
import GoogleIcon from '@mui/icons-material/Google';

const LoginButton = ({ user, onLogin }) => {
  const { t } = useTranslation();
  const googleLogin = useGoogleLogin({
    clientId: process.env.REACT_APP_GOOGLE_CLIENT_ID,
    access_type: 'offline',
    scope: 'https://www.googleapis.com/auth/adwords',
    flow: 'auth-code',
    onSuccess: async (codeResponse) => {
      try {
        const updatedUser = await googleOAUTHRedirect({
          email: user.email,
          code: codeResponse.code,
        });

        if (onLogin) onLogin(updatedUser);
      } catch (error) {
        console.error('Error during Google login:', error);
      }
    },
    onError: (errorResponse) => {
      console.error('Login Failed:', errorResponse);
    },
  });

  return (
    <Button
      onClick={googleLogin}
      variant="contained"
      startIcon={<GoogleIcon />}
      sx={{
        textTransform: 'none',
        backgroundColor: '#4285F4',
        color: '#fff',
        '&:hover': {
          backgroundColor: '#3367D6',
        },
        fontWeight: 500,
        fontSize: '14px',
        px: 3,
        py: 1.2,
        borderRadius: 2,
      }}
    >
      {t('loginButton.loginWithGoogle')}
    </Button>
  );
};

export default LoginButton;